import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Fragment } from 'vue-fragment';

import CtaButton from '@/components/CtaButton/CtaButton.vue';
import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

@Component({ components: { Fragment, CtaButton } })
export default class ButtonRow extends Vue {
  @Prop({ type: String, default: 'Submit' })
  readonly label!: string;

  @Prop({ type: Boolean, default: true })
  readonly separateLine!: boolean;

  @Prop({ type: Number as () => CtaButtonStyle, default: CtaButtonStyle.PrimaryDarkBlack })
  readonly buttonStyle!: CtaButtonStyle;

  @Prop({ type: String })
  readonly btnAlign!: string;

  @Prop()
  readonly disabled!: boolean;

  get btnAlignClass() {
    let wrapperClass: string = 'button-row__wrapper--';

    switch (this.btnAlign) {
      case 'left':
        wrapperClass += 'left';
        break;
      case 'center':
        wrapperClass += 'center';
        break;
      case 'between':
        wrapperClass += 'between';
        break;
      case 'around':
        wrapperClass += 'around';
        break;
      default:
        wrapperClass += 'right';
        break;
    }

    return wrapperClass;
  }

  get button() {
    const button: CtaLinkItem = {
      Title: this.label,
      Link: '',
      Action: 'Custom',
      ButtonStyle: this.buttonStyle,
    };

    return button;
  }

  click() {
    this.$emit('click');
  }
}
